module.exports = __webpack_public_path__ + "img/home_logo_footer.e249b59.png";